module.exports = __webpack_public_path__ + "img/Vue-FransHals-mobile.775b7920.png";